export const GET_ALL_GAMES = 'GET_ALL_GAMES';
export const GET_GAME_BY_ID = "GET_GAME_BY_ID";
export const CLEAN_GAME_DETAIL = "CLEAN_GAME_DETAIL";
export const GET_ALL_GENRES = 'GET_ALL_GENRES';
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const FILTER_BY_ORIGEN = "FILTER_BY_ORIGEN";
export const FILTER_BY_GENRE= "FILTER_BY_GENRE";
export const ORDER_GAMES = "ORDER_GAMES";
export const CREATE_GAME = 'CREATE_GAME';
export const DELETE_GAME = 'DELETE_GAME';
export const SET_LOADING = "SET_LOADING";
export const FILTER_BY_PLATFORMS= "FILTER_BY_PLATFORMS";